export const APP_URI = {
  BASE: '/',
  HOME: '/home',
  SUB: '/sub',
  NESTED_SUB: '/nested-sub',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  PROFILE: '/profile',

  CAMPAIGNS: '/campaigns',
};
